import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-auth-additional-info',
  templateUrl: './auth-additional-info.component.html',
  styleUrls: ['./auth-additional-info.component.scss']
})
export class AuthAdditionalInfoComponent implements OnInit {

  @Input() img: string;
  @Input() title: string;
  @Input() subTitle: string;

  constructor() { }

  ngOnInit() {
  }

}
